import styled, { css } from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { isAndroid, isCordova, isDesktop } from '@/helpers'


//
// Общее
//

export const SC_PageHomeWrapper = styled.div`
  background-color: ${E_Colors.GrayF5F5F7};
  min-height: calc(var(--vh100, 100vh) - 131px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
  padding-bottom: calc(16px + 82px + env(safe-area-inset-bottom, 0px));

  ${(isCordova || isAndroid || isDesktop) && css`
    padding-bottom: calc(16px + 60px + env(safe-area-inset-bottom, 0px));
  `}
`

export const SC_RoundedCard = styled.div`
  border-radius: 16px;
  border-top-right-radius: 4px;
  background-color: ${E_Colors.White};
  padding: 16px;
  margin: 0 16px;
`


//
// Основной счёт
//

export const SC_BalanceAndTransactionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const SC_LabelCommonBalance = styled.div`
  color: ${E_Colors.Gray47484B};
  font-size: 12px;
`

export const SC_BalanceCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 16px;
`

export const SC_BalanceCardTop = styled.div`
  border-radius: 16px;
  border-top-right-radius: 4px;
  background-color: ${E_Colors.White};
  padding: 16px;
`

export const SC_BalanceCardBottom = styled.div`
  border-radius: 16px;
  background-color: ${E_Colors.White};
  padding: 16px;
`

export const SC_BalanceAmount = styled.div`
  color: ${E_Colors.TextPrimary};
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  margin-bottom: 10px;
  display: flex;
  gap: 20px;

  div, a {
    display: flex;
    align-items: center;

    img {
      border: 2px solid ${E_Colors.Black};
      padding: 0 2px;
      border-radius: 8px;
      height: 36px;
    }
  }
`

export const SC_BalancePlusDisabled = styled.div`
  display: flex;
  align-items: center;
  cursor: default;
  pointer-events: none;

  && img {
    border-color: ${E_Colors.GrayC7};
    opacity: 0.45;
  }
`


//
// Сертификаты
//

export const SC_GoToAllCertificates = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin-bottom: 16px;
  cursor: pointer;

  span {
    cursor: pointer;
  }
`

export const SC_CreatedCertificatesList = styled.div`
  display: flex;
  gap: 8px;
  overflow-y: auto;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SC_SkeletonWrapper = styled.div`
  width: 100%;
`

export const SC_AddCertificate = styled.div`
  border: 1px solid ${E_Colors.GrayC7};
  border-radius: 16px;
  padding: 50px 26px 50px 20px;
  width: fit-content;
  cursor: pointer;

  [data-add] {
    pointer-events: none;
  }
`

export const SC_CertificateCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 25px;
  background-color: ${E_Colors.GrayF2};
  gap: 24px;
  position: relative;
  cursor: pointer;
`

export const SC_DenominationAndQR = styled.div`
  display: flex;
  gap: 26px;
  justify-content: space-between;
`

export const SC_Denomination = styled.div`
  display: flex;
  flex-direction: column;

  > :first-child {
    color: ${E_Colors.TextPrimary};
    font-size: 20px;
    font-weight: 600;
    white-space: pre;
  }

  > :last-child {
    color: ${E_Colors.Gray9C9CA1};
    font-size: 11px;
  }
`

export const SC_QR = styled.img`
  width: 37px;
  height: 37px;
`

export const SC_GoToAllTransactions = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin-bottom: 12px;
  cursor: pointer;

  span {
    cursor: pointer;
  }
`

export const SC_CertId = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${E_Colors.Gray66};
  color: ${E_Colors.White};
  border-radius: 16px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 4px 8px;
  font-size: 11px;
`


